// src/api/employeeLocationApi.js
import apiClient from './axios';

const employeeLocationApi = {
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const res = await apiClient.get('/employee-location/', {
      params: { page, page_size: pageSize, search },
    });
    return res.data;
  },

  create: async (data) => {
    const res = await apiClient.post('/employee-location/', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await apiClient.put(`/employee-location/${id}/`, data);
    return res.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/employee-location/${id}/`);
  },

  exportCsv: async () => {
    const res = await apiClient.get('/employee-location/export/', {
      responseType: 'blob',
    });
    return res.data;
  },
};

export default employeeLocationApi;